import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Idiomatic Tailwind class composer — combines conditional classes
 *  (`clsx`) with conflict resolution (`tailwind-merge`). Use everywhere
 *  instead of template-literal class concat. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
